// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9c12c7f6","259":"ff3f3f10","390":"e6893790","432":"7c84a093","487":"318b53b1","631":"95464ed5","801":"6084ba96","839":"2481c0c9","845":"2be9191b"}[chunkId] + ".chunk.js";
};